'use strict';
import React, { Component } from 'react';
import ProcessManager from '../../../Common/Managers/ProcessManager';

class TableRow extends Component {

    constructor(props) {
        super(props);

        this.state = {
            rutearVistaInstanciaParametro: false,
            ruta: ""
        };
        this.rutearVistaInstanciaParametro = this.rutearVistaInstanciaParametro.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.state.data = nextProps.data;
    }

    rutearVistaInstanciaParametro() {
        const { entidad } = this.props;

        const objEntidad = {
            entidadId: entidad.ID,
            rutearVistaInstancia: true,
            rutaVistaInstancia: ProcessManager.GetNextStep("VistaInstanciaParametro", "ROUTE_TO_VISTA_INSTANCIA_PARAMETRO")
        }

        this.props.setearEntidad(objEntidad);
    }

    render() {
        const { entidad, isWhiteRow } = this.props;

        let equivalenciasLbl = entidad.REQUIERE_EQUIVALENCIA ? <label className="label-grey-dark-14 atlas-text tableroPointer">{entidad.equivalencias}</label> : <label className="label-grey-dark-14 atlas-text tableroPointer"><i>{entidad.equivalencias}</i></label>

        return (
            <tr className={`atlas_seccionGrilla__registro ${isWhiteRow ? 'atlas_seccionGrilla__registro--registroBlanco' : 'atlas_seccionGrilla__registro--registroGris'}`} onClick={() => this.rutearVistaInstanciaParametro()}>
                <td>
                    <label className="label-grey-dark-14 atlas-text tableroPointer">{entidad.NOMBRE}</label>
                </td>
                <td>
                    <label className="label-grey-dark-14 atlas-text tableroPointer">{entidad.REGISTROS}</label>
                </td>
                <td>
                    {equivalenciasLbl}
                </td>
                <td>
                    <label className="label-grey-dark-14 atlas-text tableroPointer" >{entidad.productosLabel}</label>
                </td>
            </tr>
        );
    }
}

export default TableRow